import React, { createContext, FC, PropsWithChildren, useContext, useState } from 'react'

import UpgradeNowModal from '@components/organisms/UpgradeNowModal'
import { UpgradeNowModalType } from '@interfaces/components/organisms/UpgradeNowModal'
import { analytics, SegmentEvent } from '@utils/segment'

const UpgradeModalContext = createContext<{
  openUpgradeModal: (source: string, type?: UpgradeNowModalType) => void
}>({
  openUpgradeModal: () => {},
})

export const useUpgradeModal = () => {
  return useContext(UpgradeModalContext)
}

export const UpgradeModalProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [source, setSource] = useState<string>('')
  const [type, setType] = useState<UpgradeNowModalType>('default')

  const openUpgradeModal = (source: string, type?: UpgradeNowModalType) => {
    setSource(source)
    setType(type || 'default')
    setIsVisible(true)
    analytics.track(SegmentEvent.UPGRADE_NOW_MODAL_SHOWN, {
      source,
    })
  }

  const onClose = () => {
    setIsVisible(false)
    setSource('')
    setType('default')
  }

  return (
    <UpgradeModalContext.Provider value={{ openUpgradeModal }}>
      <UpgradeNowModal isVisible={isVisible} onClose={onClose} source={source} type={type} />
      {children}
    </UpgradeModalContext.Provider>
  )
}
